import {Theme} from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      color: 'rgba(255,255,255,0.8)',
      marginRight: '15px',
    },
  });

export type Styles = WithStyles<typeof styles>;
